export const ScheduleMixpanelEvents = {
  ViewedSchedule: 'Viewed Schedule',
  ViewedScheduleConfirmation: 'Viewed Schedule Confirmation',
};
